import dayjs, { type Dayjs } from 'dayjs'

function padWithZeros(number: number, minLength: number) {
  const numberString = number.toString()
  if (numberString.length >= minLength) return numberString
  return '0'.repeat(minLength - numberString.length) + numberString
}

function getRemainingSeconds(nowDayjs: Dayjs, timestampDayjs: Dayjs) {
  const seconds = timestampDayjs.diff(nowDayjs, 'seconds') % 60
  return padWithZeros(seconds, 2)
}

function getRemainingMinutes(nowDayjs: Dayjs, timestampDayjs: Dayjs) {
  const minutes = timestampDayjs.diff(nowDayjs, 'minutes') % 60
  return padWithZeros(minutes, 2)
}

function getRemainingHours(
  nowDayjs: Dayjs,
  timestampDayjs: Dayjs,
  remainingDays: string,
  daysFromInput: number,
) {
  const hours = timestampDayjs.diff(nowDayjs, 'hours')
  const days = parseInt(remainingDays, 10)
  const showTotalHours = days <= daysFromInput && days >= 1
  if (showTotalHours) {
    return padWithZeros(Math.floor(hours), 2)
  }
  const hoursWithOutDays = hours % 24
  return padWithZeros(Math.floor(hoursWithOutDays), 2)
}

function getRemainingDays(nowDayjs: Dayjs, timestampDayjs: Dayjs) {
  const days = timestampDayjs.diff(nowDayjs, 'days')
  return padWithZeros(days, 2)
}

export function getRemainingTimeUntilMsTimestamp(timestampMs: number, daysFromInput: number) {
  const timestampDayjs = dayjs(timestampMs)

  const nowDayjs = dayjs()
  if (timestampDayjs.isBefore(nowDayjs)) {
    return {
      seconds: '00',
      minutes: '00',
      hours: '00',
      days: '00',
    }
  }

  const days = getRemainingDays(nowDayjs, timestampDayjs)

  const hasDaysCountdown = parseInt(days, 10) >= daysFromInput

  return {
    seconds: getRemainingSeconds(nowDayjs, timestampDayjs),
    minutes: getRemainingMinutes(nowDayjs, timestampDayjs),
    hours: getRemainingHours(nowDayjs, timestampDayjs, days, daysFromInput),
    days: hasDaysCountdown ? days : '00',
  }
}
